


























































import mixins from 'vue-typed-mixins';
import { TableFormatOptions } from '.';
import { Question } from '@/utils/SurveyUtils';
export default mixins().extend({
  props: {
    value: {
      type: Object as () => TableFormatOptions,
    },
    questions: {
      type: Array as () => Question[],
    },
  },

  computed: {
    items(): any {
      return this.questions
        ?.filter((question) => question.questiontype.scope?.includes('table'))
        ?.map((question) => ({
          text: question.questionkey,
          value: {
            id: question.id,
          },
        }));
    },
  },

  mounted() {
    // set  values to defaults
    this.$emit('input', {
      layout: (this.value.layout || []).map((item) => ({
        header: item.header || this.$languageobj(),
        question: item.question || undefined,
      })),
    });
  },

  methods: {
    create() {
      this.value.layout.push({
        header: this.$languageobj(),
        question: undefined,
      });
    },

    async remove(index: number) {
      await this.$confirm(
        this.$i18n.tc('validation.confirmation.delete', 1, [
          this.$translate(this.value.layout[index].header) ||
            this.$i18n.tc('model.question.options.table_format.question'),
        ]),
        async () => {
          this.value.layout.splice(index, 1);
        }
      );
    },

    validQuestions(question: Question) {
      return this.items?.filter(
        (item: any) =>
          this.value.layout.findIndex(
            (value) => value.question?.id === item.value.id
          ) < 0 || item.value.id === question?.id
      );
    },
  },
});
